module.exports = __webpack_public_path__ + "img/noble4.c4b72f95.png";